import { render, staticRenderFns } from "./WidgetContainer.vue?vue&type=template&id=3af1509b&functional=true"
import script from "./WidgetContainer.vue?vue&type=script&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports